// eslint-disable-next-line @typescript-eslint/naming-convention
export enum NOTICE_TYPES {
    // 业务消息
    BUSSINESS_MESSAGE = 1,
    // 系统消息
    SYSTEM_MESSAGE = 2,
}

export interface MessageGetRes {
    content: string;
    id: string;
    noticeType: NOTICE_TYPES;
    title: string;
}
